export default __webpack_public_path__ + "static/pic-7-97a0a7f63041013d53c5423a00b38056.png";